import { render, staticRenderFns } from "./FeedRecommendation.vue?vue&type=template&id=e5aa10ba&scoped=true&"
import script from "./FeedRecommendation.vue?vue&type=script&lang=js&"
export * from "./FeedRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./FeedRecommendation.vue?vue&type=style&index=0&id=e5aa10ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aa10ba",
  null
  
)

export default component.exports